// extracted by mini-css-extract-plugin
export default {"container":"vu-z","heading":"wu-z","text":"xu-z","info":"yu-z","link":"zu-z","fullMaxWidth":"Au-z"};